import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import users from "../../../apiConfigs/users";
import { ReactComponent as Seperate } from "../../../assets/seperator.svg";
import Dropdown from "../../../designComponents/Dropdown/Dropdown";
import LabelInputField from "../../../designComponents/LabelInputField/LabelInputField";
import MediaUploader from "../../../designComponents/MediaUpload/MediaUpload";
import requestAPI from "../../../utils/requestAPI";
import { uploadFilesToS3OnlyKeys } from "../../../utils/s3Upload";
import {
  AcceptButton,
  ActiveNavText,
  ButtonsSection,
  Card,
  LabelText,
  Navigation,
  NavLink,
  NavText,
  Title,
  Wrapper,
} from "../../Properties/Details/styles";

type LandlordValues = {
  firstName: string;
  lastName: string;
  email: string;
  role: string;
};

const AddAdmin = () => {
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState<LandlordValues>({
    firstName: "",
    lastName: "",
    email: "",
    role: "OPERATOR",
  });

  const navigate = useNavigate();
  const addLandlord = async (values: LandlordValues) => {
    setLoading(true);
    let providedUrl;
    try {
      if (uploadedFile && typeof uploadedFile !== "string") {
        const uploadFiles = await uploadFilesToS3OnlyKeys({
          category: "avatar",
          fileUri: [uploadedFile],
          userId: "new ",
        });
        if (uploadFiles && uploadFiles.length > 0) {
          providedUrl = uploadFiles[0];
          await requestAPI(
            users.createAdmin({
              email: values?.email,
              firstName: values?.firstName,
              lastName: values?.lastName,
              role: values.role,
              avatar: providedUrl,
            })
          );
        }
      } else if (typeof uploadedFile === "string") {
        providedUrl = uploadedFile;
        await requestAPI(
          users.createAdmin({
            email: values?.email,
            firstName: values?.firstName,
            lastName: values?.lastName,
            role: values.role,
            avatar: providedUrl,
          })
        );
      }
      toast.success("admin added successfully");
      setLoading(false);
      navigate(-1);
    } catch (e: any) {
      setLoading(false);
      toast.error(e?.response?.data?.message || "An error occurred");
    }
  };
  return (
    <Wrapper>
      <div>
        <Title style={{ paddingBottom: 14 }}>Add Admin</Title>
        <Navigation
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <NavLink onClick={() => navigate(-1)}>
            <NavText>Table</NavText>
          </NavLink>
          <Seperate fill="#7E7E7E"></Seperate>
          <ActiveNavText>Add Admin</ActiveNavText>
        </Navigation>
      </div>
      <Card style={{ margin: 0 }}>
        <LabelText>Fill in the Form</LabelText>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 6,
            width: "100%",
          }}
        >
          <LabelInputField
            onChange={(e) => {
              setValues({ ...values, firstName: e.target.value });
            }}
            name="firstName"
            placeHolder="Type your first name eg. Alfonso"
            style={{
              label: {
                fontSize: "14px",
                fontWeight: "500",
                color: "#555A77",
              },
              input: {
                height: 50,
                border: "1px solid #F1EFFB",
                padding: 8,
                background: "#F1EFFB",
                borderRadius: 6,
                width: "100%",
              },
              container: {
                display: "flex",
                flexDirection: "column",
                gap: 6,
                paddingTop: 14,
                width: "100%", // Ensure input takes full width inside its container
              },
            }}
            label="First Name"
          />
          <LabelInputField
            onChange={(e) => {
              setValues({ ...values, lastName: e.target.value });
            }}
            name="lastName"
            placeHolder="Type your Last name eg. Alfonso"
            style={{
              label: {
                fontSize: "14px",
                fontWeight: "500",
                color: "#555A77",
              },
              input: {
                height: 50,
                border: "1px solid #F1EFFB",
                padding: 8,
                background: "#F1EFFB",
                borderRadius: 6,
                width: "100%",
              },
              container: {
                display: "flex",
                flexDirection: "column",
                gap: 6,
                paddingTop: 14,
                width: "100%",
              },
            }}
            label="Last Name"
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 6,
            width: "100%",
          }}
        >
          <LabelInputField
            onChange={(e) => {
              setValues({ ...values, email: e.target.value });
            }}
            name="email"
            placeHolder="Type your email eg. albertodelrio@email.xyz"
            style={{
              label: {
                fontSize: "14px",
                fontWeight: "500",
                color: "#555A77",
              },
              input: {
                height: 50,
                border: "1px solid #F1EFFB",
                padding: 8,
                background: "#F1EFFB",
                borderRadius: 6,
                width: "100%",
              },
              container: {
                display: "flex",
                flexDirection: "column",
                gap: 6,
                paddingTop: 14,
                width: "100%",
              },
            }}
            label="Email"
          />
          <Dropdown
            options={[
              { label: "Operator", value: "OPERATOR" },
              { label: "Customer Support ", value: "CUSTOMER_SUPPORT" },
            ]}
            onChange={(e) => {
              setValues({ ...values, role: e.target.value });
            }}
            value={values.role}
            placeHolder="Type your Last name eg. Alfonso"
            style={{
              label: {
                fontSize: "14px",
                fontWeight: "500",
                color: "#555A77",
              },
              input: {
                height: 50,
                border: "1px solid #F1EFFB",
                padding: 8,
                background: "#F1EFFB",
                borderRadius: 6,
                width: "100%",
              },
              container: {
                display: "flex",
                flexDirection: "column",
                gap: 6,
                paddingTop: 14,
                width: "100%",
              },
            }}
            label="Role"
          />
        </div>
        <MediaUploader
          label="Profile Picture"
          onChange={(e) => {
            const file = e.target.files?.[0] || null;
            setUploadedFile(file);
          }}
          style={{
            container: { paddingTop: 10, gap: 6 },
            label: { paddingBottom: 10, color: "#555A77" },
            dropzone: { background: "#F1EFFB" },
          }}
        ></MediaUploader>
      </Card>
      <ButtonsSection>
        <AcceptButton
          isLoading={loading}
          isDisabled={loading}
          onClick={() => {
            addLandlord(values);
          }}
        >
          Submit
        </AcceptButton>
      </ButtonsSection>
    </Wrapper>
  );
};

export default AddAdmin;
